import * as XLSX from 'xlsx';

// Excel dosyasından A kolonundaki şaseleri okuma
export const readExcelFile = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (e) => {
            try {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const firstSheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[firstSheetName];

                const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                const saseNumbers = jsonData
                    .map(row => row[0])
                    .filter(value => value && value.toString().trim() !== '')
                    .map(value => value.toString().trim());

                resolve(saseNumbers);
            } catch (error) {
                reject(new Error('Excel dosyası okunamadı'));
            }
        };

        reader.onerror = () => reject(new Error('Dosya okuma hatası'));
        reader.readAsArrayBuffer(file);
    });
};
// Excelin ilk kolonu "sase" olmalı
export const validateExcelHeader = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            const firstCell = jsonData[0][0];
            if (firstCell && firstCell.toString().toLowerCase().trim() === 'sase') {
                resolve({ isValid: true });
            } else {
                resolve({ isValid: false, error: 'Excel dosyasının ilk kolonu "sase" olmalı' });
            }
        };

        reader.onerror = () => reject(new Error('Dosya okuma hatası'));
        reader.readAsArrayBuffer(file);
    });
};

// Dosya validasyonu
export const validateExcelFile = (file) => {
    const validTypes = [
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ];

    if (!validTypes.includes(file.type)) {
        return { isValid: false, error: 'Lütfen geçerli bir Excel dosyası seçiniz (.xlsx veya .xls)' };
    }

    return { isValid: true };
};

// Dosya indirme işlemi
export const downloadFile = (blob, fileName) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;

    document.body.appendChild(link);
    link.click();

    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);
};

// Şablon Excel dosyası oluşturma
export const createTemplateExcel = () => {
    // Örnek şase numaraları
    const sampleData = [
        ['sase']
    ];

    // Yeni workbook oluştur
    const workbook = XLSX.utils.book_new();

    // Worksheet oluştur
    const worksheet = XLSX.utils.aoa_to_sheet(sampleData);

    // A kolonunun genişliğini ayarla
    worksheet['!cols'] = [{ wch: 25 }];

    // Workbook'a worksheet ekle
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Şase Listesi');

    // Excel dosyasını blob olarak oluştur
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    return blob;
}; 